var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('section',{staticClass:"mt-4 mb-10"},[_c('h1',{staticClass:"font-size--24",staticStyle:{"word-break":"keep-all"}},[_vm._v(" 365 오전 선정산을 위해 필요한 자료들을 체크하고 있습니다."),_c('br'),_c('br'),_vm._v(" 카드사 변경까지 모두 끝난 후에 선정산이 시작됩니다. "),_c('br')])])])
}]

export { render, staticRenderFns }